import React from 'react'
import { ArrayInput, SimpleFormIterator } from 'react-admin'
import { OptionGroup } from 'services/api/entities/catalog/optionedProduct/types/internal/optionedProduct-models'
import {
  ArrayInputContentProps,
  useKArrayInput,
} from 'services/hooks/useKArrayInput'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import LocalizedRichInputText from 'ui-shared/LocalizedFields/LocalizedRichInputText'
import ExclusiveBoolean from 'ui-shared/WrappedInputs/ExclusiveBoolean'
import SingleImageInput from 'ui-shared/WrappedInputs/SingleImageInput'
import OptionGroupSettings from './OptionGroupSettings'
import CatalogOptionsPricingInput from './pricing/CatalogOptionsPricingInput'

type Props = ArrayInputContentProps

const OptionGroupInput: React.FC<Props> = ({ source }) => {
  const { scopedFormData: optionGroup, kGetSource } =
    useKArrayInput<OptionGroup>(source!)

  // this is used by the exclusive boolean to reset itself when one of the dependencies changes
  const dependentFieldsSources = (optionGroup?.items ?? []).map((_, index) =>
    kGetSource!(`items.${index}.isDefault`)
  )

  dependentFieldsSources.push(kGetSource!('acceptsQuantity'))

  return (
    <>
      <Kdivider title="Option Group" />
      <LocalizedInputText
        source={kGetSource('name')}
        label="form.fields.name"
        fullWidth
      />
      <LocalizedRichInputText
        source={kGetSource('description')}
        label="form.fields.description"
        fullWidth
      />

      <OptionGroupSettings
        source={source}
        acceptsQuantityDependentSources={dependentFieldsSources}
      />

      <ArrayInput source={kGetSource('items')}>
        <SimpleFormIterator>
          <LocalizedInputText
            source="name"
            label="form.fields.name"
            fullWidth
          />
          <LocalizedRichInputText
            source="description"
            label="form.fields.description"
            fullWidth
          />
          {/* it prefills with "" to investigate */}
          <ExclusiveBoolean
            source="isDefault"
            label="form.fields.isDefault"
            dependentFieldsSources={dependentFieldsSources}
            defaultValue={false}
          />
          <CatalogOptionsPricingInput />

          <Kdivider />

          <SingleImageInput source="image" />
        </SimpleFormIterator>
      </ArrayInput>
    </>
  )
}

export default OptionGroupInput
